var map = {
	"./AirFreshener.png": 1410,
	"./Cat.png": 5844,
	"./ChaosEmerald.png": 1615,
	"./Disney.png": 4542,
	"./Dropping.png": 4668,
	"./ElonMusk.png": 4621,
	"./EmptyBottle.png": 3214,
	"./GenieLamp.png": 3635,
	"./HintPotion.png": 4658,
	"./HolyWater.png": 481,
	"./Insurance.png": 6138,
	"./Minusator.png": 3907,
	"./NoImage.png": 8812,
	"./OmnipotenceRing.png": 2634,
	"./RerollPotion.png": 2601,
	"./SecretList.png": 5212,
	"./Sega.png": 4377,
	"./Tanos.png": 2834,
	"./Transformer.png": 6219,
	"./Videotape.png": 2471,
	"./WheelReroll.png": 3126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5496;